export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavTitle',
        _children: ['お知らせ管理']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'お知らせ管理',
        to: '/notices',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['学校管理']
      },
      {
        _name: 'CSidebarNavItem',
        name: '学校管理',
        to: '/schools',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavItem',
        name: '先生管理',
        to: '/teachers',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['法人管理']
      },
      {
        _name: 'CSidebarNavItem',
        name: '法人管理',
        to: '/companies',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavItem',
        name: '従業員管理',
        to: '/employees',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['インポート管理']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'インポート管理',
        to: '/tasks',
        icon: 'cil-drop'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['ログインアカウント管理'],
        role: ['super_admin']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'ログインアカウント管理',
        to: '/confirm_members',
        icon: 'cil-drop',
        role: ['super_admin']
      }
    ]
  }
]
